import React from 'react';
import {useParams} from 'react-router-dom';
import {DataProvider} from './context/ConfigDataContext';
import JsonConfigEditor from './components/JsonConfigEditor';
import './styles/config.css';

const Configuration = () => {
  const {eid} = useParams();
  return (
    <div className="configurator">
      <div className="sidebar-content config-page">
        <DataProvider>
          <JsonConfigEditor eid={eid}/>
        </DataProvider>
      </div>
    </div>
  );
};
export default Configuration;
